import { createActionConst } from '../../../utils/action.utils';

const TEMPLATE_NAMESPACE = 'TEMPLATE';

export const STORE_TEMPLATE = createActionConst(TEMPLATE_NAMESPACE, 'STORE_TEMPLATE');
export const CLEAR_TEMPLATE = createActionConst(TEMPLATE_NAMESPACE, 'CLEAR_TEMPLATE');
